import { audienceSegments } from './data';

export default function WhoPodusIsForContent() {
    return (
        <div>
            <h2 className="text-2xl font-bold leading-[1.3] tracking-[-0.5px] text-foreground sm:text-[28px] lg:text-[36px]">
                Who Can Use Podus
            </h2>
            <p className="mt-3 text-xs leading-relaxed text-text-light sm:text-sm">
                Podus is designed for everyone — from individuals seeking justice to businesses managing contracts and lawyers looking to streamline their work. Whether you need quick legal guidance, affordable representation, or secure document management, Podus gives you the tools to take control of your legal journey.
            </p>

            <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2">
                {audienceSegments.map((segment) => (
                    <div
                        key={segment.number}
                        className="rounded-2xl border border-border bg-white p-5 sm:p-6"
                    >
                        <div className="mb-3 flex items-center gap-3">
                            <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-primary/10 text-sm font-bold text-primary">
                                {segment.number}
                            </span>
                            <h3 className="text-base font-bold text-foreground sm:text-lg">
                                {segment.title}
                            </h3>
                        </div>
                        <p className="text-sm leading-relaxed text-text-light">
                            {segment.description}
                        </p>
                    </div>
                ))}
            </div>
        </div>
    );
}
